const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpressJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "240px",
    height: "240px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#f0c30e",
    d: "M 104.5,-0.5 C 114.5,-0.5 124.5,-0.5 134.5,-0.5C 193.167,10.8333 228.167,45.8333 239.5,104.5C 239.5,114.5 239.5,124.5 239.5,134.5C 228.167,193.167 193.167,228.167 134.5,239.5C 124.5,239.5 114.5,239.5 104.5,239.5C 45.8333,228.167 10.8333,193.167 -0.5,134.5C -0.5,124.5 -0.5,114.5 -0.5,104.5C 10.8333,45.8333 45.8333,10.8333 104.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030200",
    d: "M 56.5,62.5 C 61.1667,62.5 65.8333,62.5 70.5,62.5C 70.5,63.8333 70.5,65.1667 70.5,66.5C 67.1667,66.5 63.8333,66.5 60.5,66.5C 60.5,68.5 60.5,70.5 60.5,72.5C 63.1667,72.5 65.8333,72.5 68.5,72.5C 68.5,73.8333 68.5,75.1667 68.5,76.5C 66.1667,76.5 63.8333,76.5 61.5,76.5C 60.5318,78.6074 60.1984,80.9407 60.5,83.5C 63.5,83.5 66.5,83.5 69.5,83.5C 69.5,84.5 69.5,85.5 69.5,86.5C 65.1667,86.5 60.8333,86.5 56.5,86.5C 56.5,78.5 56.5,70.5 56.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f0b01",
    d: "M 72.5,62.5 C 74.288,62.2148 75.9547,62.5481 77.5,63.5C 80.3426,72.8117 82.3426,72.4784 83.5,62.5C 85.5273,62.3379 87.5273,62.5045 89.5,63C 87.7016,66.7648 86.0349,70.5981 84.5,74.5C 85.6117,78.7243 87.2783,82.7243 89.5,86.5C 87.6471,87.7596 85.8138,87.7596 84,86.5C 82.0094,77.3061 79.8428,77.3061 77.5,86.5C 75.5,87.8333 73.5,87.8333 71.5,86.5C 73.9051,82.8557 75.9051,79.0224 77.5,75C 75.4052,70.9811 73.7385,66.8144 72.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070500",
    d: "M 92.5,62.5 C 96.1817,62.3347 99.8484,62.5014 103.5,63C 108.738,66.2738 109.904,70.7738 107,76.5C 104.049,78.0761 100.883,78.7428 97.5,78.5C 97.5,81.5 97.5,84.5 97.5,87.5C 95.8333,87.5 94.1667,87.5 92.5,87.5C 92.5,79.1667 92.5,70.8333 92.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f0b01",
    d: "M 112.5,62.5 C 116.182,62.3347 119.848,62.5014 123.5,63C 129.84,67.0836 130.173,71.7503 124.5,77C 126.26,80.3512 127.594,83.8512 128.5,87.5C 126.712,87.7852 125.045,87.4519 123.5,86.5C 122.305,84.2487 121.305,81.9154 120.5,79.5C 119.675,78.6143 118.675,78.281 117.5,78.5C 117.5,81.5 117.5,84.5 117.5,87.5C 115.833,87.5 114.167,87.5 112.5,87.5C 112.5,79.1667 112.5,70.8333 112.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a2203",
    d: "M 132.5,62.5 C 132.5,70.5 132.5,78.5 132.5,86.5C 136.833,86.5 141.167,86.5 145.5,86.5C 141.03,87.4861 136.363,87.8195 131.5,87.5C 131.174,78.9832 131.507,70.6499 132.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 132.5,62.5 C 136.833,62.5 141.167,62.5 145.5,62.5C 145.5,63.8333 145.5,65.1667 145.5,66.5C 142.5,66.5 139.5,66.5 136.5,66.5C 136.5,68.5 136.5,70.5 136.5,72.5C 139.167,72.5 141.833,72.5 144.5,72.5C 144.5,73.8333 144.5,75.1667 144.5,76.5C 141.833,76.5 139.167,76.5 136.5,76.5C 136.5,78.8333 136.5,81.1667 136.5,83.5C 139.5,83.5 142.5,83.5 145.5,83.5C 145.5,84.5 145.5,85.5 145.5,86.5C 141.167,86.5 136.833,86.5 132.5,86.5C 132.5,78.5 132.5,70.5 132.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f0b01",
    d: "M 152.5,62.5 C 158.178,61.3386 162.178,63.3386 164.5,68.5C 163.667,68.8333 162.833,69.1667 162,69.5C 160.162,68.4646 158.329,67.4646 156.5,66.5C 152.961,67.6345 152.628,69.4679 155.5,72C 158.759,73.2106 161.592,75.0439 164,77.5C 164.72,85.1086 161.22,88.2753 153.5,87C 149.993,85.6704 148.327,83.1704 148.5,79.5C 150.167,79.5 151.833,79.5 153.5,79.5C 153.408,83.0714 155.074,84.2381 158.5,83C 159.022,82.4387 159.355,81.772 159.5,81C 156.042,77.834 152.542,74.6673 149,71.5C 148.043,67.6386 149.21,64.6386 152.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#110c02",
    d: "M 171.5,62.5 C 174.649,62.2114 177.649,62.7114 180.5,64C 182.155,65.4443 182.822,67.2776 182.5,69.5C 179.761,69.2934 177.427,68.2934 175.5,66.5C 173.734,66.4342 172.734,67.2676 172.5,69C 176.257,71.8244 179.757,74.991 183,78.5C 182.959,86.1895 179.126,89.0229 171.5,87C 168.461,85.4229 167.128,82.9229 167.5,79.5C 169.167,79.5 170.833,79.5 172.5,79.5C 172.408,83.0714 174.074,84.2381 177.5,83C 178.022,82.4387 178.355,81.772 178.5,81C 174.924,77.9546 171.424,74.7879 168,71.5C 166.98,67.5532 168.147,64.5532 171.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6bb0e",
    d: "M 97.5,66.5 C 103.313,66.062 104.98,68.562 102.5,74C 100.866,74.4935 99.1992,74.6602 97.5,74.5C 97.5,71.8333 97.5,69.1667 97.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7af0d",
    d: "M 117.5,66.5 C 123.488,66.664 124.821,69.164 121.5,74C 120.207,74.49 118.873,74.6567 117.5,74.5C 117.5,71.8333 117.5,69.1667 117.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#937708",
    d: "M 61.5,76.5 C 61.5,78.5 61.5,80.5 61.5,82.5C 64.7131,82.19 67.7131,82.5233 70.5,83.5C 70.1667,83.5 69.8333,83.5 69.5,83.5C 66.5,83.5 63.5,83.5 60.5,83.5C 60.1984,80.9407 60.5318,78.6074 61.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4005",
    d: "M 56.5,62.5 C 56.5,70.5 56.5,78.5 56.5,86.5C 60.8333,86.5 65.1667,86.5 69.5,86.5C 69.5,85.5 69.5,84.5 69.5,83.5C 69.8333,83.5 70.1667,83.5 70.5,83.5C 70.5,84.8333 70.5,86.1667 70.5,87.5C 65.5,87.5 60.5,87.5 55.5,87.5C 55.1739,78.9832 55.5073,70.6499 56.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020200",
    d: "M 110.5,110.5 C 115.5,110.5 120.5,110.5 125.5,110.5C 125.5,128.5 125.5,146.5 125.5,164.5C 123.215,180.588 113.881,187.421 97.5,185C 89.3666,182.531 83.3666,177.531 79.5,170C 82.7899,167.016 86.4566,164.516 90.5,162.5C 93.0217,164.856 95.6884,167.023 98.5,169C 102.591,170.227 106.091,169.394 109,166.5C 110.461,147.902 110.961,129.235 110.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae8d0a",
    d: "M 110.5,110.5 C 115.64,109.512 120.974,109.179 126.5,109.5C 126.83,128.008 126.497,146.341 125.5,164.5C 125.5,146.5 125.5,128.5 125.5,110.5C 120.5,110.5 115.5,110.5 110.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070500",
    d: "M 151.5,110.5 C 163.693,107.772 173.36,111.438 180.5,121.5C 177.048,124.399 173.382,127.066 169.5,129.5C 166.324,124.084 161.657,122.251 155.5,124C 151.302,128.632 151.636,132.965 156.5,137C 164.342,139.72 171.675,143.387 178.5,148C 187.312,157.673 187.812,167.839 180,178.5C 166.828,187.805 153.662,187.805 140.5,178.5C 137.978,175.812 135.644,172.979 133.5,170C 136.923,166.872 140.757,164.372 145,162.5C 147.806,165.634 150.972,168.467 154.5,171C 160.076,172.472 164.909,171.305 169,167.5C 170.027,163.82 169.194,160.653 166.5,158C 157.642,154.656 149.475,150.156 142,144.5C 135.867,134.875 136.033,125.375 142.5,116C 145.564,114.141 148.564,112.308 151.5,110.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressJs);
export default __webpack_public_path__ + "static/media/express-js.7f974a3fa91a36643b2f1d51384de520.svg";
export { ForwardRef as ReactComponent };